import Auth from './auth';
import Check from './check';
import Message from './message';
import InformType from './InformType';
import Excel from './excel';

export default {
  Auth,
  Check,
  Message,
  InformType,
  Excel
};